module.exports = __webpack_public_path__ + "static/media/AvenirNext-UltraLight-11.625949dc.ttf";